import Form from "../../lib/aggregates/form";
const Aggregates = {
    Form,
};
export default Aggregates;
